<script lang="ts">
	import { getContext } from "svelte";
	import IntersectionObserver from "@reperio-news/core.components/IntersectionObserver.svelte";
	import Hydrator from "@reperio-news/core.components/Hydrator.svelte";
	import Config from "../../index.js";

	export let id: string;
	export let data: any;
	export let content: any = undefined;

	const context: SvelteStore<any> = getContext("context");

	if (!content) {
		if ($context.content) {
			content = $context.content.id;
		} else {
			content = $context.path;
		}
	}

	let url = `//${Config.alternateDomain || Config.domain}/videoplayer/${
		data.video.id
	}?`;

	// make videos always work in admin even if content not published
	if (__ADMIN__) {
		url =
			url + "&_reperio_admin_video=" + encodeURIComponent(data.video.url);
	}

	if (data.autoplay) {
		url += "&autoplay=1";
	}

	let intersecting: boolean = false;
	let element: HTMLIFrameElement;

	let loaded = false;

	//	element in the condition: it can be unbound mid-flight during the
	//	Hydrator branch swap, and the statement re-runs once it re-binds
	$: if (intersecting && element && !loaded) {
		// get id from window.location if no context (hydrating without context)
		// this needs improvement across the system or just use loading="lazy" when fully supported

		if (!content) {
			const m = window.location.pathname.match(/\-(\d{1,})\.html/);
			if (m) {
				content = m[1];
			}
		}

		element.src = `${url}&content=${encodeURIComponent(content)}`;
		loaded = true;
	}
</script>

<Hydrator props={$$props} component="EditorVideoPlayer" hydrate={true}>
	<IntersectionObserver {element} bind:intersecting>
		<iframe
			{id}
			bind:this={element}
			allow="autoplay; fullscreen; picture-in-picture; xr-spatial-tracking; encrypted-media"
			title="video player"
		/>
	</IntersectionObserver>
</Hydrator>

<style>
	iframe {
		width: 100%;
		height: 400px;
		border: 1px solid #111;
	}
</style>
